import classNames from 'classnames';
import { accountURL } from '../config/SiteConfig';
import Icon from '../generic/Icon';
import useUser from '../login/userContext';
import * as style from './HeaderIconLink.module.css';

export default function MyPageLink({}: { active?: boolean }) {
    const { isLoggedIn, user } = useUser();

    return (
        <a
            href={accountURL()}
            rel="nofollow"
            aria-label={isLoggedIn ? `${user.firstName} sin side` : 'Logg inn'}
            className={classNames(style.link, style.minSide)}
        >
            <Icon className="icon-my-profile-header" />
            <span>{isLoggedIn === undefined ? '\u00A0' : isLoggedIn ? user.firstName.substring(0, 25) : 'Logg inn'}</span>
        </a>
    );
}
